module.exports = __webpack_public_path__ + "img/doc/alliance-presse-magazines.jpg";